import React from 'react';
import SubpageTemplate from '../../components/SubpageTemplate';
import { Layers, Sparkles, Box, Users, Target, Rocket, Shield } from 'lucide-react';

export default function ResourceBlueprints() {
  return (
    <SubpageTemplate 
      title="Blueprints"
      subtitle="Community Architectures"
      description="Explore and fork production-ready project architectures. The Marketplace of build templates to jumpstart any project."
      icon={Layers}
      features={[
        {
          title: "Certified Blueprints",
          description: "High-fidelity templates verified by the Yacht Labs core engineering team.",
          icon: Shield
        },
        {
          title: "Community Forks",
          description: "See how other builders have customized and evolved standard architectures.",
          icon: Users
        },
        {
          title: "One-Click Import",
          description: "Instantly load any blueprint into your workbench to begin customizing.",
          icon: Box
        }
      ]}
    />
  );
}
